<script>
  import ViewCardBase from "./ViewCardBase.svelte";
  import { translate } from "../../../i18n/i18next.js";

  export let href
</script>

<ViewCardBase
  viewIconSrc="/assets/icons/icon_order_table.png"
  href={href}
>
  <span>{translate("mySchedule.views.orderTable.name")}</span>
</ViewCardBase>
